import config from '../../config';
import Dropdown from '../Dropdown/Dropdown';
import { lookupDefaultStatus, formatInputOptions } from './formHelpers';

export default function Form({
  tableName,
  data,
  title,
  handleFormChange,
  handleOnClick,
  handleStatusChange,
  selectedStatus,
  contactRole,
  descriptionWidth
}) {
  let hoverText = undefined;
  if ('hoverText' in config.tables[tableName]) {
    hoverText = config.tables[tableName]['hoverText'];
  }
  return (
    <>
      <table className='table'>
        {title ? <caption className='table-caption'>{title}</caption> : null}
        <tbody>
          {Object.keys(data).map((rowName, index) => (
            <tr key={index} className='table-rows nohover'>
              <td
                className='table-row-labels'
                style={{ width: descriptionWidth }}
              >
                {hoverText && rowName in hoverText ? (
                  <div className='hover'>
                    {rowName}
                    <span className='hover-text'>{hoverText[rowName]}</span>
                  </div>
                ) : (
                  rowName
                )}
              </td>
              <td>
                {formatInputOptions(
                  tableName,
                  rowName,
                  data[rowName],
                  handleFormChange
                )}
              </td>
            </tr>
          ))}
          {config.tables[tableName]['canUpdate'].includes(contactRole) ? (
            <tr key={'footer'} className='table-footer'>
              <td colSpan='2' className='table-row-labels'>
                <button
                  className='save-button'
                  onClick={() => {
                    handleOnClick(tableName);
                  }}
                >
                  Save Changes
                </button>
                <Dropdown
                  dropdownOptions={config.tables[tableName]['statusOptions']}
                  handleSelectedChange={handleStatusChange}
                  selectMessage='Select Status'
                  selectClassName='dropdown'
                  defaultValue={lookupDefaultStatus(selectedStatus)}
                  handleArgs={[]}
                />
              </td>
            </tr>
          ) : (
            <></>
          )}
        </tbody>
      </table>
    </>
  );
}
